import React, { useEffect, useState } from 'react'
import CustomAddPage from '../../../components/CustomComponents/CustomAddPage'
import { useTasks } from '../../../hooks/Others/Audit/useTask'

export default function AddTask({ task }) {
  const [taskData, setTaskData] = useState({
    name: '',
    active: true,
    description: '',
    taskType: '',
  })

  const { addTask, loading, updateTask } = useTasks()

  const handleTask = () => {
    if (task) {
      updateTask({ ...taskData, taskMasterId: task._id })
    } else {
      addTask(taskData)
    }
  }

  useEffect(() => {
    if (task) {
      setTaskData({
        ...task,
        permissions: task.permissions && task.permissions._id,
      })
    }
  }, [task])

  const data = [
    { label: 'Name', value: taskData.name, name: 'name' },
    { label: 'Task Type', value: taskData.taskType, name: 'taskType', options: ['AUDIT', 'POS'] },
    { label: 'Description', value: taskData.description, name: 'description' },

    // { label: 'Status', value: taskData.active, type: 'ACTIVE' },
  ]

  return <CustomAddPage heading="Task Master" redirect="ALL_TASK" currentData={task} loading={loading} state={taskData} setState={setTaskData} handleClick={handleTask} inputFields={data} />
}
